/**
 * Plage de l'écran du pilotage (contrat R-PERIODE) : la règle que le validateur du backend impose et
 * que le back-office applique à un lien pour ne jamais envoyer une plage que le serveur refuserait.
 */
import { addDaysIso, dayDiffIso } from './reapproProjectionLots.tools.js'

/** Fenêtre par défaut du pilotage, et dernier jour que le moteur prévoit : demain à J + 7. */
export const PILOTAGE_DAYS = 7
/** Plafond de la plage choisie : une plage trop large a mis Node à 100 % (incident du 01/09). */
export const PILOTAGE_PERIOD_MAX_DAYS = 31
/** Premier jour choisissable, J − 30 : de quoi lire les 31 derniers jours. */
export const PILOTAGE_PERIOD_PAST_DAYS = 30

/** Plage de l'écran, bornes comprises (`du`, `au`, dates ISO). */
export interface PilotagePeriod {
  du: string
  au: string
}

/** `date` est un jour de la plage, bornes comprises. */
export const isInPilotagePeriod = (date: string, { du, au }: PilotagePeriod): boolean =>
  date >= du && date <= au

/** Premier et dernier jours choisissables à `today` : J − 30 et J + 7. */
export const pilotagePeriodLimitsOf = (today: string): { min: string; max: string } => ({
  min: addDaysIso(today, -PILOTAGE_PERIOD_PAST_DAYS),
  max: addDaysIso(today, PILOTAGE_DAYS),
})

/** Pourquoi une plage est refusée à `today` ; `null` si elle est lisible. */
export const pilotagePeriodDefectOf = (
  { du, au }: PilotagePeriod,
  today: string,
): string | null => {
  if (au < du) return `La plage finit le ${au}, avant de commencer le ${du}`
  if (dayDiffIso(du, au) + 1 > PILOTAGE_PERIOD_MAX_DAYS) {
    return `Plage de ${PILOTAGE_PERIOD_MAX_DAYS} jours au plus`
  }
  const { min, max } = pilotagePeriodLimitsOf(today)
  return du < min || au > max ? `Plage hors des jours lisibles (${min} à ${max})` : null
}
